import React from 'react';

import Icon from './Icon';

const FirmwareUpdateBlueIcon = (props) => {
    return (
        <Icon width='48' height='48' {...props}>
            <g fill='none' fillRule='evenodd'>
                <path
                    d='M22.332 35.92h-2.996c-2.549 0-4.643-2.008-4.668-4.473V18.325H9.11a.924.924 0 0 1-.529-1.68l13.907-9.728a.92.92 0 0 1 1.058 0l13.907 9.728a.924.924 0 0 1-.529 1.68h-5.557v5.231a.922.922 0 0 1-1.846 0v-6.154c0-.51.413-.922.923-.922h3.551L23.017 8.798 12.04 16.48h3.552c.51 0 .923.412.923.922V31.43c.015 1.457 1.28 2.642 2.822 2.642h2.996a.924.924 0 0 1 0 1.847'
                    fill='#272830'
                />
                <path
                    d='M30.141 24.478c-4.115 0-7.462 3.347-7.462 7.463 0 4.114 3.347 7.464 7.462 7.464 4.116 0 7.463-3.35 7.463-7.464 0-4.116-3.347-7.463-7.463-7.463zm0 16.772c-5.132 0-9.308-4.177-9.308-9.309 0-5.134 4.176-9.308 9.308-9.308 5.133 0 9.31 4.174 9.31 9.308 0 5.132-4.177 9.309-9.31 9.309z'
                    fill='#282930'
                />
                <path d='M35.414 31.941a5.273 5.273 0 1 1-10.546 0 5.273 5.273 0 0 1 10.546 0' fill='#00D1D2' />
                <path
                    stroke='#34303D'
                    strokeWidth='2'
                    strokeLinecap='round'
                    strokeLinejoin='round'
                    d='m27.594 32.506 1.379 1.443 3.498-3.594'
                />
            </g>
        </Icon>
    );
};

export default FirmwareUpdateBlueIcon;
